<template>
  <div class="navcontainer _navcontainer">
     <div class="appleicon _appleicon" @click="tohome" style="width:auto;">
       <!-- <i class="iconfont icon-pingguo" > -->
       <img src="/static/img/63fddb7f6f5f4c5da930abd8509b5c6.png" alt="" style="height:40px;margin-left:30px;">
       <!-- </i> -->
       </div>
      <div class="shopcar">
        <!-- 3<i class="iconfont icon-gouwuche"></i> -->
    </div>
  <!-- <div class="navicon _navicon"  @click="opencaidan()"><i class="iconfont icon-caidan"></i></div> -->
  <div class="navicon _navicon"  @click="nalistshowflag = !nalistshowflag"><i class="iconfont icon-caidan"></i></div>
  <van-popup v-model="nalistshowflag" :duration="0.5" position="right" :style="{ height: 'calc(100% - 59px)'}" style="margin-top:29px;" >
        <div id="navID" class="mainnavlist _mainnavlist">
      <div class="guanbi">
        <div v-for="(tab,_index) in menulist" :key="tab.id">
          <div class="nav_title" @click="navchang(tab.id)" :class="{active: navid == tab.id}">
            <span style="color:#e3e3e3">{{'0'+(_index+1)}}</span>
            <span>{{tab.name}}</span>
            <span style="width:17px;display:inline-block;"></span>
          </div>
          <div v-if="tab.subCategories.length>0">
                <div  @click="navchang(item.id,item.name,item.thimbnail,item.post_id)" class="nav_title1" v-for="item in tab.subCategories" :key="item.id" :class="{active:navid == item.id}">{{item.name}}</div>
          </div>
        </div>
        <!-- <div @click="routerpush('/ipad')">iPad</div>
        <div @click="routerpush('/iphone')">iPhone</div>
        <div @click="routerpush('/watch')">Watch</div>
        <div @click="routerpush('/music')">Music</div> -->
      </div>
    </div>
      </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import {julihemenulist} from '../../api/jslihe'
export default {
  name: 'navtop',
  components: {
    [Popup.name]: Popup
  },
  props: {
    navid: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      nalistshowflag: false,
      menulist: []
    }
  },
  mounted () {
    console.log(this.navid)
    this.getmenulist()
  },
  watch: {
    $route: function (to, from) {
      this.nalistshowflag = false
    }
  },
  methods: {
    navchang (id, name, img, articleid) {
      console.log(id)
      if (id === 19) {
        // 联系我们
        this.$router.push({path: 'music', query: {id: id}})
      } else if (id === 15) {
        // 成功案例
        this.$router.push({path: 'watch', query: {id: id}})
      } else if (id === 22) {
        // 企业荣誉
        this.$router.push({path: 'iphone', query: {id: id}})
      } else if (id === 25) {
        this.$router.push({path: 'home', query: {id: id}})
      } else if (id === 24 || id === 17 || id === 18) {
        // 团队风采 企业新闻  健康实训
        this.$router.push({path: 'ipad', query: {id: id, name: name, img: img}})
      } else if (id === 27 || id === 21 || id === 23 || id === 3 || id === 2 || id === 5 || id === 6 || id === 7 || id === 8 || id === 28 || id === 10 || id === 11 || id === 26 || id === 12 || id === 13 || id === 14 || id === 27) {
        // 文章页
        this.$router.push({path: 'mac', query: {id: id, articleid: articleid, name: name, img: img}})
      } else {
        return false
      }
    },
    getmenulist () {
      julihemenulist().then(res => {
        console.log(res)
        this.menulist = res.data
        console.log(this.menulist)
      })
    },
    tohome () {
      this.nalistshowflag = false
      this.$router.push({path: 'home'})
    },
    routerpush (to) {
      this.nalistshowflag = false
      this.$router.push({path: to})
    }
    // 当屏幕宽度小于800的时候，点击菜单图标，显示隐藏的菜单
    // opencaidan () {
    //   var dom = document.getElementById('navID')
    //   if (dom.classList.contains('navlistshow')) {
    //     dom.classList.remove('navlistshow')
    //   } else {
    //     dom.classList.add('navlistshow')
    //   }
    // },
    // // 当屏幕宽度小于800的时候，点击关闭按钮， 关闭菜单
    // closecaidan () {
    //   var dom = document.getElementById('navID')
    //   if (dom.classList.contains('navlistshow')) {
    //     dom.classList.remove('navlistshow')
    //   }
    // }
  }
}
</script>
<style>
.van-overlay{
 margin-top: 60px;
 height: calc(100% - 60px);
}
</style>
<style lang="less" scoped>
.active{
  color:#409EFF!important;
}
// 小于800px
    ._navcontainer{
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    background-color: #fff;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    z-index: 10000;
     animation:topnav 1s 1 linear;
    ._navicon{
        width: 82px;
    }
    ._appleicon{
        width: 100px;
    }
    ._mainnavlist{
        display: flex;
        flex-direction: column;
        z-index: 1999 !important;
        width:40vw ;
        color:rgb(214, 214, 214);
        padding-bottom: 2vh;
        .guanbi{
          width:100%;
          height:100%;
          .nav_title{
            color:#000;
            font-weight: bold;
            font-size: 1rem;
            line-height: 30px;
            width: 100%;
            display: flex;
    justify-content: space-around;
          }
          .nav_title1{
            line-height: 30px;
            width: 100%;
            // border-bottom: 1px solid rgb(214, 214, 214);
            color:#333;
            text-align:center;
            font-size: 0.8rem;
          }
        }
    }
    .shopcar{
        width: 100px;
    }
    }
    @keyframes topnav{
           0%{
               padding-bottom:60px;
           }
           100%{
            padding-bottom:0px;
           }
        }
    .navlistshow{
        display: block !important;
        ._mainnavlist .guanbi{
          animation:out11 1.3s 1 linear!important;
        }
        @keyframes out11{
           0%{
               margin-left:100%!important;
           }
           100%{
            margin-left: 65%!important;
           }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/NavTop.vue